module.exports = __webpack_public_path__ + "static/media/error-small.2afd8269.svg";